import {
  type AgentAddUserBankAccountInput,
  type AgentGetBankAccountsInput,
  type AgentSetDefaultBankAccountInput,
} from '../api'
import { api } from '../api'

const create = async (data: AgentAddUserBankAccountInput) => {
  return await api.v1.agentAddBankAccount({
    ...data,
  })
}

const get = async (data: AgentGetBankAccountsInput) => {
  return await api.v1.agentListBankAccounts({
    ...data,
  })
}

const remove = async (ids: number[]) => {
  return await api.v1.agentDeleteBankAccounts({
    ids,
  })
}

const setDefault = async (data: AgentSetDefaultBankAccountInput) => {
  return await api.v1.agentSetDefaultBankAccount({
    ...data,
  })
}

export default {
  create,
  get,
  remove,
  setDefault,
}
